/*eslint-disable*/
// components/RenderReport.tsx
import React from 'react';
import moment from 'moment';
import { Editor, Frame } from '@craftjs/core';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { InteractionModeProvider } from '../contexts/InteractionMode';
import InputField from '../BuilderInputField/InputField';
import SnapCanvas from '../SnapCanvas/SnapCanvas';
import CheckboxField from '../Checkbox/CheckboxField';
import MultilineTextbox from '../MultilineTextbox/MultilineTextbox';
import UploadArea from '../UploadArea/UploadArea';
import DropdownField from '../DropdownField/DropdownField';
import DatePickerField from '../DatePicker/DatePicker';
import TimePickerField from '../TimePickerField/TimePickerField';

import {
  buildReportDataIndex,
  hydrateOutputLayoutWithReport,
} from './utils/reportHydration';
import styles from './styles/styles.module.css';
interface RenderReportProps {
  stateAccessor:
    | 'checklistLayouts'
    | 'inventoryLayouts'
    | 'reportLayouts'
    | 'trackerLayouts';
}

export default function RenderReport({ stateAccessor }: RenderReportProps) {
  const params = useParams();
  const report = useSelector(
    (state: any) => state.reportData.indexByReportId[(params as any).id]
  );
  const tz = useSelector((state: any) => state.currentSite.timezone);
  const layoutJson = useSelector(
    (state: any) => state.reportLayouts[stateAccessor][report?.reportLayoutId]
  );

  // 1) Build index from submitted data
  const dataIndex = React.useMemo(() => {
    return buildReportDataIndex(report?.serializedData || '[]');
  }, [report?.serializedData]);

  // 2) Merge into layout (read-only hydration)
  const hydratedLayout = React.useMemo(() => {
    if (!layoutJson) return '{}';
    return hydrateOutputLayoutWithReport(
      layoutJson.serializedLayout,
      dataIndex,
      {
        propAllowlist: ['value', 'label'], // optional
        includeLabels: true,
      }
    );
  }, [layoutJson, dataIndex]);

  if (!report || !layoutJson) {
    return <div>Report or layout missing.</div>;
  }

  const layoutObject = JSON.parse(hydratedLayout);

  function getHeadlineDate() {
    for (let i = 0; i < Array.from(Object.values(layoutObject)).length; i++) {
      const value = Array.from(Object.values(layoutObject))[i] as any;
      //eslint-disable-next-line
      if (value.displayName == 'DatePickerField') {
        if (value.props.isCreationDate) {
          return moment(value.props.value).tz(tz).format('MM-DD-YYYY');
        } else {
          return moment(report.submittedAt).tz(tz).format('MM-DD-YYYY');
        }
      }
    }
  }

  return (
    <div style={{ height: '100%', width: '100%' }}>
      <div className={styles.headlineContainer}>
        <p className={styles.reportName}>
          {report.reportName != 'undefined'
            ? report.reportName
            : report.previewLabel}
        </p>
        <p className={styles.reportName}>{getHeadlineDate()}</p>
      </div>

      <InteractionModeProvider value="VIEW">
        <Editor
          enabled={false} // READ-ONLY for final report view
          resolver={{
            SnapCanvas,
            InputField,
            CheckboxField,
            MultilineTextbox,
            UploadArea,
            DropdownField,
            DatePickerField,
            TimePickerField,
          }}
          onRender={(renderNode) => {
            const el = renderNode.render as React.ReactElement<any>;

            // Inject your custom prop here
            return React.cloneElement(el, {
              dataMode: true,
            });
          }}
        >
          <Frame data={hydratedLayout} />
        </Editor>
      </InteractionModeProvider>
    </div>
  );
}
